import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import { Circle } from '@bubble-ui/primitive-circle';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotLikeComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotLike',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1FDC81",
    d: "M7.5 11.5 14 3.608a1.669 1.669 0 0 1 2.892 1.52L15.5 10h3.494a2 2 0 0 1 1.95 2.443l-1.413 6.222A3 3 0 0 1 16.605 21h-6.443a3 3 0 0 1-2.996-3.158L7.5 11.5Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#02AF5C",
    d: "M3 12a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7Z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 5.5,
    cy: 18.5,
    r: 1.5,
    fill: "#1FDC81"
  }));
};
SpotLikeComponent.displayName = 'SpotLike';
export var SpotLike = withProvisionalOverrideFromContext(SpotLikeComponent);
//# sourceMappingURL=index.js.map